module.exports = __webpack_public_path__ + "img/placeholder_header_4.0a17aa65.jpg";